const globalConstants = {
    FullUrl: process.env.REACT_APP_FULL_URL,
    GoogleMap_Key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    AppKey: process.env.REACT_APP_APP_KEY,
    AppSecret: process.env.REACT_APP_APP_SECRET,
    SiteKey: process.env.REACT_APP_CAPTCHA_KEY,
    AnalyticsKey: process.env.REACT_APP_ANALYTICS_KEY,
    GTMKey: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY,

    FieldTypes: {
        String: 'string',
        Phone: 'phone',
        Integer: 'int',
        Boolean: 'boolean',
    },
    MaxAllowedDigitsInPhoneNumber: 10,
    maxPhoneNumbers: 6,
    PhoneNumberFormat: '(999) 999-9999',
    MaxLength: {
        ItemsToDeliver: 100,
        SpecialInstructions: 300
    },
    MaxItemAllowed: 5,
    SkuItemMaxWeight: 250,
    RoundToNearestMinuteValue: 5,
    LowerTimeMins: 60,
    UpperTimeMins: 60,
    TeletBuffer: 1.5,
    DateTimeFormat: 'YYYY/MM/DD HH:mm:ss',
    DateFormat: 'YYYY-MM-DD',
    DateFormat2: 'YYYY/MM/DD',
    HourFormat: 'hh:mm A',
    HourFormat2: 'HH:mm:ss',
    HourFormat3: 'HH:mm',
    DayFormat: 'dddd',
    DayTimeFormat: 'ddd, MMM DD [at] hh:mm A z',
    GAEventNames: {
        Pagination: 'Pagination',
        DeliveryFilterApply: 'Delivery Filter Apply',
        DeliveryFilterReset: 'Delivery Filter Reset',
        SearchDeliveries:"Search Deliveries",
        ClearSearch:"Clear Search",
        ViewDeliveryDetails:"Delivery Details View",
        ScheduleBungii:"Schedule Bungii",
        BackToQuote:"Back To Quote/Edit",
        NewBungii:"New Bungii",
        StartOver:"Start Over",
        EditPickupAddress:"Edit Pickup Address",
        GetEstimate:"Get Estimate",
        WhatsNeededInfo:"What's Needed Info",
        CancelDelivery:"Cancel Delivery",
        ViewDashboard:"View Dashboard",
        Logout:"Logout",
        NewDelivery:"New Delivery",
        HeadsUpCancel:"Heads Up Cancel",
        HeadsUpContinue:"Heads Up Continue",
        PartnerLogo:"Partner Logo",
        GenerateReports:"Generate Reports",
        EmailSupport:"Email Support",
        FillOutThisFormLink:"Fill Out This Form Link",
    },
    PageLabels: {
        ScheduleDelivery:"Schedule Delivery",
        DeliveryCost:"Delivery Cost",
        Pallet: "Pallet",
        LargeItemTwoDrivers: 'Large item(s) - 2 drivers',
    },
    ButtonLabels: {
        Apply: "Apply",
        Reset: "Reset",
    },
    CustomEventNames: {
        OpenReportsModal: "bungii-open-reports-modal",
    },
    Dashboard: {
        OverviewHeaderTitle: "Overview",
        OverviewHeaderTooltipMessage:
            "Current Deliveries stats are updated on each page refresh, other stats are updated daily",
        DeliveryListHeading: "Delivery List",
        DeliveryListSummaryText:
            "Showing all In-Progress & Scheduled deliveries, and Completed deliveries from past 2 weeks. View older deliveries in",
        DeliveryListSummaryReportsLabel: "Reports",
        DeliveryListNoRecordsMessage: "No active or recent deliveries found",
    }
}


export default globalConstants;
